import smartSolveApi from './instances/smartsolve';

export const getSearchTreeViewData = async (entityName, skipValidation = false) => {
  try {
    const response = await smartSolveApi.post('/searchtreeviewdata', {
      entityName,
      skipValidation,
    });
    return response.data;
  } catch (e) {
    throw new Error(`searchtreeviewdata failed: ${e}`);
  }
};

export const getEnhancedSearchTreeViewData = async (entityName) => {
  try {
    if (entityName !== '' && entityName !== 'ALL') {
      const response = await smartSolveApi.post('/enhancedglobalsearchandtreeviewdata', {
        entityName,
      });
      return response.data;
    } else {
      return {};
    }
  } catch (e) {
    throw new Error(`getEnhancedSearchTreeViewData failed: ${e}`);
  }
};
